var config = {
      meta: {
        title: "Eetplein",
        description: "Eetplein, Eerlijk bestellen bij jouw in de buurt",
        meta: [
          { name: 'description', content:  'Iedereen heeft wel zijn vaste pizzeria, chinees, friet- of shoarmatent. En vaak heb je ook al bepaald wat je het lekkerst vindt en dus het vaakst neemt. Eetplein.nl brengt deze zaken samen in 1 app, je eigen eetplein!'},
          { property: 'og:title', content: "Eetplein, Eerlijk bestellen bij jouw in de buurt"},
          { property: 'og:site_name', content: 'Eetplein'},
          {property: 'og:type', content: 'website'},    
          {name: 'robots', content: 'index,follow'} 
      ]},
      page: {
        width: 1160,
        columnWidth: 700,
        contentWidth: 700,
        bannerHeight: 250,
        drawerWidth: 400,
        banner: require("./assets/storebanner.png"),
        splash: require("./assets/splash.png"),
        name: "Mijn eetplein",
        type: ["all","pizza","friet","shoarma","sushi","kip","test"],
      },
      testapi: {
        url: process.env.NODE_ENV !== "production" ? "http://localhost:3000" : "https://test.openorder.nl", //"https://test.openorder.nl", //
        key: "TEST_0KFWsQyZtUKlWwsyiK64jECM0Ls_Q-G-"
      },
      api: {
        url: "https://api.openorder.nl", //"https://api.openorder.nl", "http://localhost:3000"
        key: "0KFWsQyZtUKlWwsyiK64jECM0Ls_Q-G-"
      },
      oneSignal: {
        appId : '7b2cefb4-dac5-4156-a88d-a7737f95dc4f',
        appIdTest: '6cdbc4ec-4938-44ec-b8da-dd634bcbe2e9'//process.env.NODE_ENV == 'development' ?  : '7b2cefb4-dac5-4156-a88d-a7737f95dc4f'
      },
      firebase : {
        col: "bestelinfo",
        apiKey: "AIzaSyCgtKBaUtw_g9P_9LOwAaO1TFs89ZbBu64",
        authDomain: "spaces-c9a15.firebaseapp.com",
        databaseURL: "https://spaces-c9a15.firebaseio.com",
        projectId: "spaces-c9a15",
        storageBucket: "spaces-c9a15.appspot.com",
        messagingSenderId: "743473985149",
        appId: "1:743473985149:web:54a49d9eb85e2a8cae2314",
      },
      public_url: 'https://mijn.eetplein.nl/', //process.env.NODE_ENV == 'development' ? 'https://test.eetplein.nl/' : 'https://mijn.eetplein.nl/',
      public_test_url: 'https://test.eetplein.nl/',
      google: {
        appId: "spaces-c9a15",
        mapsKey: "AIzaSyDwDPq6Ac2huKiNvV2rrQ-Lu_WQSWDPtm0",
      },
     status: [
        {value:'concept', text: 'Concept', next: 'new', action: 'Nieuwe bestelling', edit: true, payed: true},
        {value:'new', text: 'Nieuw', next: 'order', action: 'Nieuwe Bestelling', tab: true, date: true, edit: true, payed: true,delete:true,message:true},
        {value:'order', text: 'In bestelling', next: 'done', action: 'Accepteren', tab: true, date: true,  edit: true, payed: true,delete:true,message:true},
        {value:'done', text: 'Klaar', next: 'archive', action: 'Klaar', tab: true, edit: true, payed: true, check:['payed'],message:true},
        {value:'deliver', text: 'Bezorgingen', tab: true},
        {value:'archive', text: 'Opgeslagen', next: 'hide', action: 'Afgehaald', action_deliver: "Bezorgd",  edit: false, payed: false, delete: true,message:true},
        {value:'hide', text: 'Archief', action: 'Verbergen', edit: false, payed: false, delete: true},
        {value:'pending', text: 'Ingepland', action: 'Inplannen', edit: false, payed: false,tab: false, date: true,},
        {value:'active', text: 'Actief'},
    ],
    allergens: [
      {value: 'pork', text: 'Varkensvlees', icon: 'mdi-pig-variant', color: 'pink lighten-4'},
      {value: 'mild', text: 'Mild', icon: 'mdi-chili-mild', color:'green'},
      {value: 'medium', text: 'Medium', icon: 'mdi-chili-medium', color:'orange'},
      {value: 'hot', text: 'Heet', icon: 'mdi-chili-hot', color:'red'},
      {value: 'veggie', text: 'Vegetarisch', icon: 'mdi-food-apple-outline', color:'green'},
      {value: 'peanut', text: 'Pinda', icon: 'mdi-peanut', color:"brown"},
      ],
     payment: [
        {value: 'cash', text:'Contant', icon: 'mdi-cash-multiple'},
        {value: 'pin', text:'PIN', icon: 'mdi-dialpad'}, 
        {value: 'ideal', provider: 'mollie', text:'iDEAL', icon: 'mdi-credit-card-check-outline', price: 0.29, description: 'Betalingen via mollie.com', website: "https://www.mollie.com"},
        {value: 'ideal', provider: 'ccv', text:'iDEAL', icon: 'mdi-credit-card-check-outline', price: 0.29, description: 'Betalingen via CCV', website: "https://www.ccv.eu/"},
      ],
     reviewstatus: ['mdi-star-plus-outline',
      'sentiment_very_dissatisfied',
      'sentiment_dissatisfied',
      'sentiment_neutral',
      'sentiment_satisfied',
      'sentiment_very_satisfied'
    ],
    paymentstatus: {
        none: {text:"Succes", description: "Bedankt voor je bestelling. We gaan deze voor je in orde maken.", icon: 'check_circle', color: 'primary'}, 
        cash: {text:"Succes", description: "Bedankt voor je bestelling. We gaan deze voor je in orde maken.", icon: 'check_circle', color: 'primary'},
        pin: {text:"Succes", description: "Bedankt voor je bestelling. We gaan deze voor je in orde maken.", icon: 'check_circle', color: 'primary'},
        onsite: {text:"Succes", description: "Bedankt voor je bestelling. We gaan deze voor je in orde maken. Je kunt betalen bij het afhalen.", icon: 'check_circle', color: 'primary'},
        ondelivery: {text:"Succes", description: "Bedankt voor je bestelling. We gaan deze voor je in orde maken. Je kunt betalen bij het bezorgen.", icon: 'mdi-truck-delivery-outline', color: 'primary'},
        open: {text:"Open", description: "De betaling staat nog open. Probeer het nog eens.", icon: "hourglass_empty", color:'primary', retry: true},
        canceled: {text:"Geannuleerd", description: "De betaling is geannulleerd. Probeer het nog eens.", icon: "close", color:'red', retry: true},
        pending: {text:"Doorgevoerd", description: "De betaling wordt doorgevoerd. Een moment geduld alstublieft", icon: "hourglass_empty", color:'primary'},
        authorized: {text:"Geauthoriseerd", description: "De betaling wordt geauthoriseerd. Een moment geduld alstublieft", icon: "hourglass_empty", color:'primary'},
        expired: {text:"Verlopen", description: "De betaling is verlopen. Probeer het nog eens.", icon: "hourglass_empty", color:'orange', retry: true},
        failed: {text:"Fout", description: "Er is iets misgegaan met de betaling. Probeer het nog eens.", icon: "close", color:'red', retry: true},
        paid: {text:"Betaald", description: "De betaling is sucesvol. We gaan de bestelling voor je in orde maken.", icon: 'check_circle', color: 'primary'},
        ideal: {text:"IDEAL betaling", description: "Online betaling met ideal", icon: 'check_circle', color: 'primary'},
        thuisbezorgd: {text:"Thuisbezorgd", description: " Dank voor je bestelling via Thuisbezorgd. Deze site kost ons relatief veel geld daarom vragen we je om ons eigen bestelwebsite te gebruiken. Deze is makkelijker door herhaalbestellingen en je verdiend er stempels mee voor gratis gerechten, de eerste krijg je van ons!", icon: 'food_bank', color: 'primary'},
       
  },
  source: [ 
    {value:'app', text: 'App', icon: 'mobile_friendly', hide: true},
    {value:'internet', text: 'Internet', icon: 'person_pin', hide: true},
    {value:'phone', title: 'Telefonische bestelling', text: 'Telefoon', icon: 'mdi-face-agent', color:"green", description: "Zoek op mobielnummer of voer een nieuw nummer<br>Voer het 10 cijferige telefoonnummer in."},
    {value:'desk', title: 'Balie bestelling', text: 'Balie', icon: 'mdi-store', color:"indigo", description:"Zoek op mobielnummer of voer een nieuw nummer<br> Voer het 10 cijferige telefoonnummer in."},
    {value:'thuisbezorgd', title: 'Thuisbezorgd bestelling', text: 'Thuisbezorgd.nl', icon: 'food_bank', color:'warning', description:"Zoek op mobielnummer of voer een nieuw nummer<br> in om de thuisbezorg klant in te voeren."},//mdi-silverware-fork-knife
    //mdi-truck-delivery-outline
  ],
    landing: {
        default: [
        { 
          animation: '/img/tenor.gif',
          title: 'Welkom!', 
          subtitle: null,
          description: `Bestel voortaan via deze eetplein app en spaar meer voor gratis extra's`,
          next: 'Volgende',
        },{
        title: "Bestellen",
        description: "Zoek je favoriete restaurant in je buurt en bestel snel een eenvoudig.", 
        done: 'Beginnen',
        }
    ],
    home: [
      { 
        img: "../../src/assets/login.png",
      title: 'Welkom', 
      description: `Heb je een actiecode? Voer deze dan nu in:`
      },
  ],
        login: [
          { 
          img: "../../src/assets/login.png",
          title: 'Welkom', 
          description: `Lekker lokaal bestellen`,
          done: 'Doorgaan',
          }
      ],
   },
      menus: ["favorite","all","pizza","shoarma","grieks","friet","sushi","chinees","broodje","surinaams", "spare ribs","kip","spaans"],

      menu: {
        "favorite": {
          src: '/img/001-cutlery.png',
          color: '#673AB7',
          iconClass: 'grey lighten-1 white--text',
          title: 'Favoriet',
          description: "Overzicht van al mijn favoriete restaurants",
          icon: 'mdi-home',
          show: false
        },
        "all": {
          src: '/img/001-cutlery.png',
          color: '#673AB7',
          iconClass: 'grey lighten-1 white--text',
          title: 'Alle',
          description: "Overzicht van alle restaurants",
          icon: 'mdi-home',
          show: false
        },
        "test": {
          src: '/img/food/009-pizza.png',
          color: '#4CAF50',
          iconClass: 'grey lighten-1 white--text',
          title: 'Test',
          description: "Selecteer en bestel bij je favoriete pizzatent",
          icon: 'mdi-pizza',
          show: false,
        
        },
        "pizza": {
          src: '/banner/pizza.jpg',
          color: '#1B5E20',
          iconClass: 'grey lighten-1 white--text',
          title: 'Pizza',
          description: "Selecteer en bestel bij je favoriete pizzatent",
          icon: 'mdi-pizza',
          show: true,
          
        },
        "friet": {
          src: '/banner/snackbar.jpg',
          title: 'Cafetaria',
          color: '#006064',
          icon: 'mdi-food',
          description: "Selecteer en bestel bij je favoriete frietent",
          show: true,
        
        },
        "shoarma": {
          src: '/banner/grillroom.jpg',
          color: '#B71C1C',
          title: 'Shoarma',
          icon: 'mdi-food-steak',
          description: "Selecteer en bestel bij je favoriete shoarmatent",
          show:true,
        },
        "sushi": {
          src: '/banner/sushi.jpg',
          color: 'amber',
          title: 'Sushi',
           icon: 'mdi-noodles',
           description: "Selecteer en bestel bij je favoriete sushi tent",
           show: true,
           /*"_relation": {
            "id": "9CRNYBRc2dQVLeiA6Dvb",
            "name": "Maan Sheng"
          }*/
        },
         "broodje": {
          color: '#E65100',
          title: 'Broodjes',
           icon: 'breakfast_dining',
           description: "Heerlijke broodjes",
           show: true,
           /*"_relation": {
            "id": "9CRNYBRc2dQVLeiA6Dvb",
            "name": "Maan Sheng"
          }*/
        },
        "chinees": {
          src: '/banner/chinees.jpg',
          color: '#E65100',
          title: 'Chinees',
           icon: 'mdi-noodles',
           description: "## Binnenkort beschikbaar",
           show: true,
           /*"_relation": {
            "id": "9CRNYBRc2dQVLeiA6Dvb",
            "name": "Maan Sheng"
          }*/
        },
        "thais": {
          src: '/img/food/007-noodles.png',
          color: '#4A148C',
          title: 'Thais',
          icon: 'mdi-noodles',
          show:false,
        },
        "surinaams": {
          src: '/img/food/007-noodles.png',
          color: '#4A148C',
          title: 'Surinaams',
          icon: 'mdi-pasta',
          show:false,
        },
        "grieks": {
          src: '/img/food/007-noodles.png',
          color: '#4A148C',
          title: 'Grieks',
          icon: 'mdi-library-shelves',
          show:false,
        },"spare ribs": {
          src: '/img/food/007-noodles.png',
          color: '#4A148C',
          title: 'Spare ribs',
          icon: 'mdi-food-steak',
          show:true,
        },
        "kip": {
          src: '/img/food/005-roast chicken.png',
          color: '#795548',
          title: 'Kip',
          icon: 'mdi-food-drumstick-outline',
          description: "Selecteer en bestel bij je favoriete kiprestaurant",
          show:false,
        },
        "Spaans": {
          src: '/img/food/005-roast chicken.png',
          color: '#795548',
          title: 'Spaans',
          icon: 'mdi-food-drumstick-outline',
          description: "Selecteer en bestel bij je favoriete spaanse restaurant",
          show:false,
        }
      },
      printers : [{value: 'thermal2', text: "Star mC-Print2"},
      {value: 'thermal3', text: "Star mC-Print3"}],
      rules: {
        required: (value) => !!value || 'Verplicht.',
        min: (v) =>v &&  v.length >= 8 || 'Tenminste 8 tekens',
        min2: (v) => v && v.length >= 4 || 'Tenminste 4 tekens',
        max11: (v) => v && v.length <= 11 || 'Maximaal 11 tekens',
        code: (v) => !v || v.toString().length == 4 || 'Ongeldige code',
        code5: (v) => !v || v.toString().length == 5 || 'Ongeldige code',
        time: (value) => {
          var pattern = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/
          return pattern.test(value) || 'Ongeldige tijd'
        },
        zipcode: (value) => {
          var pattern = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
          return pattern.test(value) || 'Ongeldige postcode'
        },
        phone: (value) => {
          var pattern = /^(?=^.{10,11}$)0\d*-?\d*$/
          return pattern.test(value) || 'Ongeldig telefoonnummer'
        },
        mobile: (value) => {
          if (!value) return false
          if (value && value.substring && value.length>1 && value.substring(0,2) !='06')  return 'Vul je 06 nummer in'
          if (value.length<10) return false
          if (value.length>10) return 'Vul je 10 cijferige nummer in'
          
          var pattern = /^\d{10}$/
          return pattern.test(value) || 'Ongeldig nummer'
        },
        mac: (value) => {
          var pattern = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$/; 
          return pattern.test(value) || 'Ongeldig mac adres'
        },
        email: (value) => {
          if (!value) return true
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Ongeldig e-mail adres.'
        },
        url: (value) =>{
          if (!value) return true
          const pattern = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
          return pattern.test(value) || 'Ongeldig website adres.'
        }
      },
      stamps: {
        max: 10,
        value: 10,
      },
      eetplein: {
        delivery: {
          description:  "Zin om bij ons eten te bestellen maar geen zin om het op te halen. Bekijk via onderstaande knop op welke postcodes wij bezorgen. Wij doen ons best best om binnen 45 minuten aan jouw voordeur te staan."
        },
        order: {
          description:  "Uiteraard is het mogelijk om je bestelling bij ons af te halen. Wil je snel geholpen worden? Bestel eenvoudig en snel op onze eigen website en wij zorgen dat je eten klaar staat op het door jou gekozen tijdstip. Betaal direct online snel en veilig met iDEAL, zo hoef je aan de balie niets meer af te rekenen."
        }
      },
      none: ['Geen','Zonder', 'Zonder saus','Geen saus','Kies'],
      include:{
        'default': {
          title: "${label}",
          description: 'Wil je ${label} bij je ${product.name.toLowerCase()}',
          required: 'Kies je ${label} bij je ${product.name.toLowerCase()}',
          extra: 'Wil je nog extra ${label} bij je ${product.name.toLowerCase()}?',
          top: 5
        },
        'dranken': {
          title: "Drankje",
          description: 'Wat wil je drinken bij je ${product.name.toLowerCase()}?',
          top: 5
        },
        'milkshakes': {
          title: "Milkshake",
          description: 'Wil je een milkshake bij je ${product.name.toLowerCase()}?',
          top: 5
        },
        'met': {
          title: "${label}",
          description: 'Wat wil je bij je ${product.name.toLowerCase()}?',
          top: 5
        },
        'extra': {
          title: "${label}",
          description: 'Extras toevoegen',
          top: 5
        },
        "saus-shoarma": {
          title: 'Saus',
          multiple: "sauzen",
          description: 'Kies een saus bij je ${product.name.toLowerCase()}',
          extra: 'Wil je nog extra saus bij je ${product.name.toLowerCase()}?',
          top: 5
        },
        'saus' : {
          title: 'Saus',
          multiple: "sauzen",
          description: 'Kies een saus bij je ${product.name.toLowerCase()}',
          extra: 'Kies een extra saus bij je ${product.name.toLowerCase()}',
          top: 5
        },
        'sauzen' : {
          title: 'Sauzen',
          description: 'Kies een of meerdere sauzen voor bij je ${product.name.toLowerCase()}',
          extra: 'Kies een extra sauzen bij je ${product.name.toLowerCase()}',
          top: 5
        },
        'groenten':{
          title: 'Groenten',
          description: "Selecteer welke groenten je wilt",
          extra: 'Wil je nog extra groente(n) tevoegen?',
          top: 10
        },
        'broodje':{
          title: 'Broodje',
          description: "Wil je nog een (extra)broodje",
          extra: 'Wil je nog extra groente(n) tevoegen?',
          top: 10
        },
        'kaas':{
          title: 'Extra kaas',
          description: "Wil je kaas op je ${product.name.toLowerCase()}",
          extra: "Wilt u nog extra kaas toevoegen",
          top: 10
        },
        'calzone':{
          title: 'Pizza calzone',
          description: "Wil je van je ${product.name} een Calzone maken?",
          top: 10
        },
        'toppings' : {
          title: 'Topping',
          description: 'Dit zit er op je ${product.name}',
          top: 10
        },
        'bevat' : {
          title: 'Bevat',
          description: '${product.name} bevat',
          top: 10
        },
        'beleg' : {
          title: 'Topping',
          description: 'Dit zit er op je ${product.name}',
          top: 10
        },
        'ingrediënten' : {
          title: 'Ingrediënten',
          description: 'Dit zit er in je ${product.name}',
          top: 10
        },
      }
  };
  try {
    module.exports = exports = config;
  } catch (e) {}
  